import merge from "lodash-es/merge";
import cloneDeep from "lodash-es/cloneDeep";
import { defaultConfig } from "../../../lib/defaults";
import { arrayify } from "../../../lib/utils";
const defaults = defaultConfig.baseLayoutComponents;
export function getBaseLayout(uc, key, children = [], extra) {
  var _uc$config;
  const def = (uc === null || uc === void 0 || (_uc$config = uc.config) === null || _uc$config === void 0 || (_uc$config = _uc$config.baseLayoutComponents) === null || _uc$config === void 0 ? void 0 : _uc$config[key]) || defaults[key];
  let ans = typeof def === 'string' ? {
    type: def
  } : cloneDeep(def);
  ans.children = arrayify(children);
  if (extra) ans = merge(ans, extra);
  return ans;
}